import { ComponentProps, JSXElementConstructor } from 'react';
import {
  Modal,
  BottomSheetComponent,
  NavigationConfig,
  ParamListBase,
  registerBottomSheets,
  registerNavigationHandlers,
  registerModals,
  hideHeader,
} from '@betty/navigation';
import UploadDocumentsNavigator from '../navigators/UploadDocumentsNavigator';
import AddressVerificationScreen from '../screens/AddressVerificationScreen/AddressVerificationScreen';
import AcceptableDocuments from './AcceptableDocumentsBottomSheet/AcceptableDocumentsBottomSheet';
import AddressVerification from '../components/AddressVerification/AddressVerification';
import Onboarding from './OnboardingBottomSheet/OnboardingBottomSheet';
import OnfidoEntry from './OnfidoEntryBottomSheet/OnfidoEntryBottomSheet';
import OnfidoModal from './OnfidoModal/OnfidoModal';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'AddressVerificationScreen', // TODO: should be full screen modal
      options: {},
      component: AddressVerificationScreen,
    },
    {
      name: 'UploadDocumentsScreen',
      options: hideHeader,
      component: UploadDocumentsNavigator,
    },
  ],
};

declare global {
  interface AppNavigatorParamsList extends ParamListBase {
    AddressVerificationScreen: undefined;
    UploadDocumentsScreen: undefined;
  }
}

const bottomSheets = {
  AcceptableDocuments,
  Onboarding,
  OnfidoEntry,
};

const modals = {
  Onfido: OnfidoModal,
  AddressVerification: AddressVerification,
  UploadDocuments: UploadDocumentsNavigator,
};

registerBottomSheets('onboarding', bottomSheets);

registerNavigationHandlers<
  AppNavigatorParamsList,
  'AddressVerificationScreen' | 'UploadDocumentsScreen'
>({
  AddressVerificationScreen() {
    Modal.open({
      namespace: 'onboarding',
      type: 'AddressVerification',
      data: {
        onVerified: Modal.close,
      },
    });
  },
  UploadDocumentsScreen() {
    Modal.open({
      namespace: 'onboarding',
      type: 'UploadDocuments',
      options: {
        hideHeader: true,
      },
      style: {
        width: 512,
        height: 600,
        paddingTop: 'space-200',
      },
    });
  },
});

registerModals('onboarding', modals);

declare global {
  interface RegisteredModals {
    onboarding: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}

declare global {
  interface RegisteredBottomSheets {
    onboarding: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
